import React from "react";
import PopUpMessage from './PopUpMessage';
import PopUpBeneficiary from './PopUpBeneficiary';
import PopUpDeeplink from './PopUpDeepLink';
import PopUpContact from './PopUpContact';
import PopUpExistingProcess from './PopUpExistingProcess';
import PopUpContradiction from  './PopUpContradiction';
import './popup.scss'

export const popupWin = (props) => {

  const renderComponent = () => {
    switch (props.type) {
      case 'message':
        return (<PopUpMessage {...props} />);
      case 'beneficiary':
        return (<PopUpBeneficiary {...props} />);
      case 'deeplink':
        return (<PopUpDeeplink {...props} />);
        case 'contradiction':
          return (<PopUpContradiction {...props} />);
        case 'contactUs':
          return (<PopUpContact {...props} />);
          case 'existingProcess':
          return (<PopUpExistingProcess {...props} />);
      default:
        return <></>;
    }
  };

  window.popup({ "element": renderComponent(), "specialTitle": props.specialTitle || null, "hideClose": props.hideClose || false, "handleClose": props.handleClose, "className": props.className })
};

